/* eslint-disable @typescript-eslint/no-unused-vars */
import { FunctionComponent, ReactElement, useContext, useEffect, useRef, useState } from 'react';
import { GenderInput, GenderInputDS, SelectedButton } from '../../components/DesignSystem';
import { ModalContainer } from '../../containers/Modal/ModalContainer';
import { Nationality, NationalityInput } from '../../store/constants';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { BirthInfoModel, CountryItem, NationalityInfoModel } from '../../store/store.model';
import { ValidityHtmlElement } from '../../utils/DsType';
import NationalityModal from './components/NationalityModal';
const initBirthInfo: BirthInfoModel = {
  birthDepartment: {
    label: '',
    code: '',
    displayedLabel: '',
  },
  birthDate: '',
  // birthCity: { department: '', inseeNumber: '', name: '', zipCode: '' },
};

const Nationalite: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const {
    state: { holder },
    dispatch,
    dispatchModalStatus,
  } = useContext(store);
  const nationalityRef = useRef<GenderInputDS>(null);
  const birthCountryRef = useRef<GenderInputDS>(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [scope, setScope] = useState<string>('');
  const [selectedCountryState, setSelectedCountryState] = useState<CountryItem>({} as CountryItem);
  const [input, setInput] = useState<string>('');
  const { nationality, birthCountry } = (holder?.identity ?? {}) as NationalityInfoModel;

  const onClose = () => {
    setModalOpen(false);
  };
  const checkNationalityInupt = () => {
    if (!!nationalityRef && nationalityRef.current !== null) {
      (nationalityRef.current as unknown as GenderInputDS).value =
        holder?.identity?.nationality && holder?.identity?.nationality.countryCode === 'FR'
          ? Nationality.FRENCH
          : holder?.identity?.nationality && (holder?.identity?.nationality as CountryItem).nationalityCode
          ? Nationality.OTHER
          : undefined;
      (nationalityRef.current as unknown as ValidityHtmlElement).assignValidity();
    }
  };
  const checkBirthCounbtryInupt = () => {
    if (!!birthCountryRef && birthCountryRef.current !== null) {
      (birthCountryRef.current as unknown as GenderInputDS).value =
        holder?.identity?.birthCountry && holder?.identity?.birthCountry.countryCode === 'FR'
          ? Nationality.FRENCH
          : holder?.identity?.birthCountry && (holder?.identity?.birthCountry as CountryItem).countryCode
          ? Nationality.OTHER
          : undefined;
      (birthCountryRef.current as unknown as ValidityHtmlElement).assignValidity();
    }
  };
  useEffect(() => {
    if (!isModalOpen) {
      if (scope === NationalityInput.NATIONALITY) {
        checkNationalityInupt();
      } else if (scope === NationalityInput.BIRTH_COUNTRY) {
        checkBirthCounbtryInupt();
      }
    }
  }, [isModalOpen]);

  const dispatchSelectedCountry = () => {
    if (scope === NationalityInput.NATIONALITY) {
      dispatch(updateStore({ holder: { identity: { nationality: selectedCountryState } } }));
    } else if (
      scope === NationalityInput.BIRTH_COUNTRY &&
      holder?.identity?.birthCountry?.countryCode !== selectedCountryState?.countryCode
    ) {
      dispatch(updateStore({ holder: { identity: { birthCountry: selectedCountryState } } }));
    }
  };
  const onListCountrySelected = (event: Event) => {
    setSelectedCountryState((event as CustomEvent).detail.value as CountryItem);
  };

  useEffect(() => {
    dispatchSelectedCountry();
  }, [selectedCountryState]);

  const onNationalityChange = (event: Event) => {
    if (!!nationalityRef && nationalityRef.current !== null) {
      (nationalityRef.current as unknown as ValidityHtmlElement).assignValidity();
      if ((event as CustomEvent).detail.value.value !== Nationality.FRENCH) {
        const nationality = { nationalityCode: 'A', countryCode: 'AU', label: 'Autre' };
        // setModalOpen(true);
        dispatch(updateStore({ holder: { identity: { nationality } } }));
      }
      if ((event as CustomEvent).detail.value.value === Nationality.FRENCH) {
        const nationality = { nationalityCode: 'F', countryCode: 'FR', label: 'FRANCE' };

        // setModalOpen(true);
        dispatch(updateStore({ holder: { identity: { nationality } } }));
      }
    }
    // const nationality = { nationalityCode: 'F', countryCode: 'FR', label: 'FRANCE' };
    // if (!!nationalityRef && nationalityRef.current !== null) {
    //   (nationalityRef.current as unknown as ValidityHtmlElement).assignValidity();
    //   dispatch(updateStore({ holder?.identity: { nationality } }));
    // }
  };
  const onClickNationality = () => {
    // setScope(NationalityInput.NATIONALITY);
    // setInput(nationality && nationality?.countryCode !== 'FR' ? nationality.label : { label: '' }.label);
    const nationality = { nationalityCode: 'A', countryCode: 'AU', label: 'Autre' };
    // setModalOpen(true);
    dispatch(updateStore({ holder: { identity: { nationality } } }));
  };
  const onBirthCountryChange = (event: Event) => {
    if (!!birthCountryRef && birthCountryRef.current !== null) {
      (birthCountryRef.current as unknown as ValidityHtmlElement).assignValidity();
      if ((event as CustomEvent).detail.value.value !== Nationality.FRENCH) {
        const birthCountry = { nationalityCode: 'A', countryCode: 'AU', label: 'AUTRE' };
        const birthDepartment = { code: '99', label: '', displayedLabel: '' };
        dispatch(
          updateStore({
            holder: {
              identity: { birthCountry, birthDepartment },
              // , birthInfo: initBirthInfo
            },
          }),
        );
      }
      if ((event as CustomEvent).detail.value.value === Nationality.FRENCH) {
        const birthCountry = { nationalityCode: 'F', countryCode: 'FR', label: 'FRANCE' };
        dispatch(updateStore({ holder: { identity: { birthCountry } } }));
      }
    }
    // const birthCountry = { nationalityCode: 'F', countryCode: 'FR', label: 'FRANCE' };
    // // resset BirthInfo on change birthCountry
    // // if (!!birthCountryRef && birthCountryRef.current !== null) {
    // (birthCountryRef.current as unknown as ValidityHtmlElement).assignValidity();
    // dispatch(updateStore({ holder?.identity: { birthCountry }, birthInfo: initBirthInfo }));
    // }
  };
  const onClickBirthCountry = () => {
    // setScope(NationalityInput.BIRTH_COUNTRY);
    // setInput(birthCountry && birthCountry?.countryCode !== 'FR' ? birthCountry.label : { label: '' }.label);
    // setModalOpen(true);
    const initBirthInfo = { nationalityCode: 'A', countryCode: 'AU', label: 'Autre' };
    // setModalOpen(true);
    dispatch(updateStore({ holder: { identity: { birthCountry } } }));
  };
  return (
    <>
      <GenderInput
        ref={nationalityRef}
        label="Nationalité"
        class="to-validate trackable-click"
        data-id="nationality"
        onSelectedElementChange={onNationalityChange}
        value={
          holder?.identity?.nationality && holder?.identity?.nationality.countryCode === 'FR'
            ? Nationality.FRENCH
            : holder?.identity?.nationality && (holder?.identity?.nationality as CountryItem).nationalityCode
            ? Nationality.OTHER
            : undefined
        }
        error-message="Veuillez choisir votre nationalité."
      >
        <SelectedButton id="french-nationality-select-button" value={Nationality.FRENCH} secondary>
          Française
        </SelectedButton>
        <SelectedButton id="french-nationality-select-button" value={Nationality.OTHER} secondary>
          Autre
        </SelectedButton>
        {/* <SelectedButton
          id="other-nationality-select-button"
          className="E3-untrackable"
          onClick={onClickNationality}
          value={Nationality.OTHER}
          secondary
        >
          {holder?.identity?.nationality && holder?.identity?.nationality.countryCode !== 'FR'
            ? holder?.identity?.nationality?.label
            : 'Autre'}
        </SelectedButton> */}
      </GenderInput>

      <GenderInput
        ref={birthCountryRef}
        label="Pays de naissance"
        class="to-validate trackable-click"
        data-id="birthCountry"
        error-message="Veuillez choisir votre pays de naissance."
        onSelectedElementChange={onBirthCountryChange}
        value={
          holder?.identity?.birthCountry && holder?.identity?.birthCountry.countryCode === 'FR'
            ? Nationality.FRENCH
            : holder?.identity?.birthCountry && holder?.identity?.birthCountry?.countryCode === 'AU'
            ? Nationality.OTHER
            : undefined
        }
      >
        <SelectedButton value={Nationality.FRENCH} secondary>
          France
        </SelectedButton>
        <SelectedButton value={Nationality.OTHER} secondary>
          Autre
        </SelectedButton>
        {/* <SelectedButton
          id="other-birthcountry-select-button"
          className="E3-untrackable"
          onClick={onClickBirthCountry}
          value={Nationality.OTHER}
          secondary
        >
          {holder?.identity?.birthCountry && holder?.identity?.birthCountry.countryCode !== 'FR'
            ? holder?.identity?.birthCountry?.label
            : 'Autre'}
        </SelectedButton> */}
      </GenderInput>
      <ModalContainer withComboInput isOpen={isModalOpen} onListSelected={onListCountrySelected} onClose={onClose}>
        <NationalityModal input={input} scope={scope} />
      </ModalContainer>
    </>
  );
};

export default Nationalite;
